module.exports = __webpack_public_path__ + "img/thank-logo-shou.436dfa03.png";